/* istanbul ignore file */
import classnames from 'classnames/bind'
import {
  NOTIFICATION_ROLES,
  useApplicationNotifications,
  LoginForm,
  useApplicationTheme,
} from '@adc/ui-adc'
import logger from '@adc/logger'
import {
  redirectToListingView,
  useStepManagerContext,
} from '../steps/stepManager'
import styles from './styles.scss'

const cx = classnames.bind(styles)

const PasswordField = () => {
  const { data, actions } = useStepManagerContext()
  const theme = useApplicationTheme()
  const { leadIntake, listingId } = data
  const { setIsLoading } = actions
  const notifications = useApplicationNotifications()
  const onSuccess = () => {
    setIsLoading(true)
    redirectToListingView(listingId, theme, true)
  }
  const onFail = (error: Error) => {
    const { message = '' } = error as Error
    notifications.toast.open({
      role: NOTIFICATION_ROLES.ERROR,
      title: 'Something went wrong',
      message,
    })
    logger.error(JSON.stringify(error))
  }

  const loginFormInitialValues = {
    email: leadIntake.email,
    rememberEmail: false,
  }
  return (
    <div className={cx('login-form-wrapper')}>
      <LoginForm
        initialValues={loginFormInitialValues}
        onFail={onFail}
        onSuccess={onSuccess}
        elmId={`conversational_form_login`}
        passwordOnly
        cta='Log in to continue'
      />
    </div>
  )
}

export default PasswordField
